/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as AdminDefs from './defs.defs'
import * as RepoStrongRef from '../repo/strongRef.defs'

const $nsid = 'com.atproto.admin.updateSubjectStatus'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  subject: /*#__PURE__*/ l.typedUnion(
    [
      /*#__PURE__*/ l.typedRef<AdminDefs.RepoRef>(
        (() => AdminDefs.repoRef) as any,
      ),
      /*#__PURE__*/ l.typedRef<RepoStrongRef.Main>(
        (() => RepoStrongRef.main) as any,
      ),
      /*#__PURE__*/ l.typedRef<AdminDefs.RepoBlobRef>(
        (() => AdminDefs.repoBlobRef) as any,
      ),
    ],
    false,
  ),
  takedown: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<AdminDefs.StatusAttr>(
      (() => AdminDefs.statusAttr) as any,
    ),
  ),
  deactivated: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<AdminDefs.StatusAttr>(
      (() => AdminDefs.statusAttr) as any,
    ),
  ),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  subject: /*#__PURE__*/ l.typedUnion(
    [
      /*#__PURE__*/ l.typedRef<AdminDefs.RepoRef>(
        (() => AdminDefs.repoRef) as any,
      ),
      /*#__PURE__*/ l.typedRef<RepoStrongRef.Main>(
        (() => RepoStrongRef.main) as any,
      ),
      /*#__PURE__*/ l.typedRef<AdminDefs.RepoBlobRef>(
        (() => AdminDefs.repoBlobRef) as any,
      ),
    ],
    false,
  ),
  takedown: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<AdminDefs.StatusAttr>(
      (() => AdminDefs.statusAttr) as any,
    ),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Update the service-specific admin status of a subject (account, record, or blob). */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
